module.exports = __webpack_public_path__ + "static/img_dele.0e967980.svg";